/**
 * 权限定义
 */

const ACCESSENUM = {
  NOT_LOGIN: "not_login",
  USER: "user",
  ADMIN: "admin",
};
export default ACCESSENUM;
